// utils/FieldRenderRegistry.js
// Registre des composants de rendu front (FormBuilderRender)
// ----------------------------------------------------------

import { RenderTextField } from "../admin/controls/text";
import { RenderTextareaField } from "../admin/controls/textarea";
import { RenderEmailField } from "../admin/controls/email";
import { RenderNumberField } from "../admin/controls/number";
import { RenderTelField } from "../admin/controls/tel";
import { RenderUrlField } from "../admin/controls/url";
import { RenderSelectField } from "../admin/controls/select";
import { RenderSelectMultipleField } from "../admin/controls/selectMultiple";
import { RenderCheckboxField } from "../admin/controls/checkbox";
import { RenderRadioField } from "../admin/controls/radio";

import { RenderDateField } from "../admin/controls/date";
import { RenderDatetimeField } from "../admin/controls/datetime";
import { RenderFileField } from "../admin/controls/file";






import { RenderStaticTitleField } from "../admin/controls/staticTitle";
import { RenderStaticTextField } from "../admin/controls/staticText";
import { RenderSeparatorField } from "../admin/controls/separator";

import { RenderPersonField } from "../admin/controls/person";
import { RenderAddressField } from "../admin/controls/address";
import { RenderCompanyField } from "../admin/controls/company";

import { RenderLayout2colsField } from "../admin/controls/layout2cols";
import { RenderLayout3colsField } from "../admin/controls/layout3cols";
// ----------------------------------------------------------
// Mapping des types de contrôles vers leur composant React
// ----------------------------------------------------------
export default {
  text: RenderTextField,
  textarea: RenderTextareaField,
  email: RenderEmailField,
  number: RenderNumberField,
  tel: RenderTelField,
  url: RenderUrlField,
  select: RenderSelectField,
  selectMultiple: RenderSelectMultipleField,
  checkbox: RenderCheckboxField,
  radio: RenderRadioField,
  date: RenderDateField,
  datetime: RenderDatetimeField,
  file: RenderFileField,
  staticTitle: RenderStaticTitleField,
  staticText: RenderStaticTextField,
  separator: RenderSeparatorField,
  person: RenderPersonField,
  address: RenderAddressField,
  company: RenderCompanyField,
  layout2cols: RenderLayout2colsField,
  layout3cols: RenderLayout3colsField,
};
